module.exports = __webpack_public_path__ + "img/sun2.4e16f41a.svg";